<div class="munily-qty-stepper" (click)="$event.preventDefault()">
  <button
    type="button"
    class="munily-qty-stepper__btn"
    [disabled]="disabled || value <= min"
    [attr.aria-label]="decreaseAriaLabel"
    (click)="onClick($event, value - 1)"
  >-</button>
  <input
    type="text"
    inputmode="numeric"
    class="munily-qty-stepper__input"
    [value]="draft"
    [disabled]="disabled"
    (click)="$event.stopPropagation()"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />
  <button
    type="button"
    class="munily-qty-stepper__btn"
    [disabled]="disabled || value >= max"
    [attr.aria-label]="increaseAriaLabel"
    (click)="onClick($event, value + 1)"
  >+</button>
</div>